export const DomesticContentAttestmentModalLabels = {
  pvOnly: {
    label: 'Submit for Solar DC Review',
    description:
      'I confirm that this project meets LightReach Domestic Content guidance for solar components to the best of my knowledge.',
    warning:
      'This project qualifies for PV Only. By selecting a different option, you may trigger additional reviews and could lead to Install Package rejection. Are you sure you want to continue?',
  },
  storageOnly: {
    label: 'Submit for Storage DC Review',
    description:
      'I confirm that this project meets LightReach Domestic Content guidance for storage components to the best of my knowledge.',
    warning:
      'This project qualifies for Storage Only. By selecting a different option, you may trigger additional reviews and could lead to Install Package rejection. Are you sure you want to continue?',
  },
  pvAndStorage: {
    label: 'Submit for Solar+Storage DC Review',
    description:
      'I confirm that this project meets LightReach Domestic Content guidance for both solar and storage components to the best of my knowledge.',
    warning:
      'This project qualifies for PV + Storage. By selecting a different option, you may trigger additional reviews and could lead to Install Package rejection. Are you sure you want to continue?',
  },
  optOut: {
    label: 'Opt out of DC Boost for this Project',
    description:
      'I understand that this project will be eligible for Milestone Payments based off the non-Domestic Content value.',
    warning:
      'This project does not qualify for Domestic Content. By selecting a different option, you may trigger additional reviews and could lead to Install Package rejection. Are you sure you want to continue?',
  },
};
